function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import React from "react";

var _ref2 = React.createElement("path", {
  d: "M17.774865 2.84625C18.36057 2.26035 18.36057 1.31085 17.774865.7251C17.1891.13935 16.23954.13935 15.653775.7251L5.9946 10.384275C5.10255 11.27676 5.10255 12.72321 5.9946 13.615725L15.653775 23.274903C16.23957 23.8606242 17.1891 23.86066365 17.774865 23.274903C18.36063 22.689138 18.360585 21.739605 17.774865 21.15381L8.6211 12 17.774865 2.84625Z"
});

var SvgCaretLeftBold = function SvgCaretLeftBold(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCaretLeftBold, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/caret-left-bold.ae93797e.svg";
export { ForwardRef as ReactComponent };